




































import { Component, Vue } from 'vue-property-decorator';

import { AssessmentInstance, ProgressStatus } from '../models';
import { httpGet } from '../utils';

@Component
export default class AboutView extends Vue {
  private isLoading: boolean = true;
  private isError: boolean = false;
  private errorMessage: string = '';
  private assessments: AssessmentInstance[] = [];

  get assessment(): AssessmentInstance {
    return this.assessments[0];
  }

  get assessmentHasBeenStarted(): boolean {
    return this.assessment.sections.some((s) => s.progress === ProgressStatus.InProgress ||
      s.progress === ProgressStatus.Completed);
  }

  get buttonText(): string {
    return this.assessmentHasBeenStarted ? 'Continue Your Assessment' : 'Start Your Assessment';
  }

  private created() {
    const url = `${process.env.VUE_APP_API_HOST}/assessments/`;
    httpGet<AssessmentInstance[]>(url)
      .then((assessments) => {
        this.assessments = assessments;
      }).catch((error) => {
        this.errorMessage = error.message;
        this.isError = true;
      }).then(() => {
        this.isLoading = false;
      });
  }
}
